import User from "./User"
import DegreeStore from "./Degree";
import BranchStore from "./Branch";
import AdminStore from "./Admins";
import SectionStore from "./Section";
import SubjectStore from "./Subject";
import FacultyStore from "./Faculty";
import FacultyOptions from "./FacultyOptions";
import FacultyGroup from "./FacultyGroup.js";
import StudentOptions from "./StudentOptions";
import Appstore from "./Appstore";
import FilesView from "./FilesView"
import FacultyFilesViewStore from "./FacultyFilesView";

export const useUserStore = User;
export const useAppStore = Appstore;
export const useDegreeStore = DegreeStore;
export const useBranchStore = BranchStore;
export const useAdminStore = AdminStore;
export const useSectionStore = SectionStore;
export const useSubjectStore = SubjectStore;
export const useFacultyStore = FacultyStore;
export const useFacultyOptionsStore = FacultyOptions;
export const useFacultyGroupStore = FacultyGroup;
export const useStudentOptionsStore = StudentOptions;
export const useFilesViewStore = FilesView;
export const useFacultyFilesViewStore = FacultyFilesViewStore;